/**
 * 인증 토큰, 시스템 키 입력 안내 설명문 추가
 * @param spec
 * @param isWorkSpaceSpec
 */
const addSecurityDescription = (spec: any, isWorkSpaceSpec: boolean) => {
  spec.info.description = `
  ${spec.info.description}
  
  ### server API 호출 시 주의사항
  NHN커머스에서 제공하는 server API 에는 Token Bucket 방식이 적용되어 있습니다.<br>
  이는 짧은 시간 안에 API를 과도하게 호출할 경우 오류가 발생할 수 있기 때문에 **안정적인 서비스 제공**을 위해 도입된 방식입니다.<br>
  1초에 100회 이상 API를 대량 호출할 시 아래의 응답을 받을 수 있습니다.

  | 코드 | 메시지 |
  | --- | --- |
  | 429 | Too Many Requests |

  이러한 상황을 방지하기 위해 NHN커머스에서는 API 응답헤더에 ratelimit-available-level 값을 함께 제공합니다.<br>
  ratelimit-available-level 값이 EXHAUSTED 상태로 표시될 경우 잠시 호출을 중단해 주세요.<br>
  EXHAUSTED 상태에서 호출을 계속 이어갈 경우 429 오류가 반복적으로 발생할 수 있어 주의가 필요합니다.<br>
  <br>
  ### 인증 설정 안내
  
  API를 호출하려면 **인증 토큰**과 **시스템 키**가 필요합니다. 아래 절차에 따라 인증을 설정 해주세요.
  ${isWorkSpaceSpec ? '<br>(토큰 발급 API 의 경우 인증 없이 호출 가능 합니다.)' : ''}
  
  1. **Authorize 버튼 클릭**<br>화면 오른쪽 상단에 있는 **"Authorize"** 버튼을 클릭하면 인증 정보 입력 창이 활성화 됩니다.
  2. **Authorize 적용**<br>인증 토큰, 시스템 키를 각각 입력 후 **"Authorize"** 버튼을 클릭하면 인증이 적용 됩니다.
  3. **API 호출**<br>인증이 설정되면 이후 API 요청 시 자동으로 인증 헤더가 포함 됩니다. 이제 모든 API 엔드포인트에 접근 가능합니다.
  `;

  return spec;
};

export default addSecurityDescription;
